import { render, staticRenderFns } from "./labelText.vue?vue&type=template&id=2bc5394a&"
import script from "./labelText.vue?vue&type=script&lang=js&"
export * from "./labelText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports